import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { InBodyResult } from '../../model';
import type { AssessmentResultInbodyCompositionResultDataFragment } from '@/pages/PhysicalResultPage/shared/AssessmentResults.api';

const parseInbody = (t: TFunction, items: AssessmentResultItemDataFragment[]): InBodyResult | null => {
    const item = items.find(i => i.result.__typename === 'InbodyCompositionResult');
    const mi = item?.moduleInstance;
    const r = item?.result as AssessmentResultInbodyCompositionResultDataFragment;
    if (!mi?.name || !r) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.weight'),
                value: r.weightKg != null ? Number(r.weightKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.bodyFatMass'),
                value: r.bodyFatMassKg != null ? Number(r.bodyFatMassKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.fatFreeMass'),
                value: r.fatFreeMassKg != null ? Number(r.fatFreeMassKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.skeletalMuscleMass'),
                value:
                    r.skeletalMuscleMassKg != null ? Number(r.skeletalMuscleMassKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.totalBodyWater'),
                value: r.totalBodyWater != null ? Number(r.totalBodyWater).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.inbody.bodyFatPercentage'),
                value: r.bodyFatPercentage != null ? Number(r.bodyFatPercentage).toFixed(2) : t('traineeReports:na'),
            },
        ],
        segmentalData: {
            ffmOfRightArmKg: r.ffmOfRightArmKg ?? undefined,
            ffmOfRightArmPercentage: r.ffmOfRightArmPercentage ?? undefined,
            ffmOfLeftArmKg: r.ffmOfLeftArmKg ?? undefined,
            ffmOfLeftArmPercentage: r.ffmOfLeftArmPercentage ?? undefined,
            ffmOfTrunkKg: r.ffmOfTrunkKg ?? undefined,
            ffmOfTrunkPercentage: r.ffmOfTrunkPercentage ?? undefined,
            ffmOfRightLegKg: r.ffmOfRightLegKg ?? undefined,
            ffmOfRightLegPercentage: r.ffmOfRightLegPercentage ?? undefined,
            ffmOfLeftLegKg: r.ffmOfLeftLegKg ?? undefined,
            ffmOfLeftLegPercentage: r.ffmOfLeftLegPercentage ?? undefined,
        },
    };
};

export default parseInbody;
